import { AUCTION_EVENTS } from '../../event_bus_modules/auction_bidding';
import { formatAmount } from './auction_formatter';

const AMOUNT_ATTRIBUTE = 'data-amount';

$(() => {
  // decrease, increase and auto bid buttons
  const autoBidButton = $('#auto-bid-button');
  const autoBidConfirmButton = $('.auto-bid-confirm-button');
  const autoBidAmountElement = $('#auto-bid-amount');
  const currentBidDisplayElement = $('#current-bid-amount');
  const bidUntilDisplayElement = $('#bid-until-amount');
  const currentBidInModalDisplayElement = $('#current-amount-in-auto-modal');

  const onAutoBidClicked = () => {
    const autoBidAmount = autoBidAmountElement.attr(AMOUNT_ATTRIBUTE);
    const autoBidValue = parseInt(autoBidAmount);
    const currentBid = currentBidDisplayElement.attr(AMOUNT_ATTRIBUTE);
    bidUntilDisplayElement.text(formatAmount(autoBidAmount));
    bidUntilDisplayElement.attr('data-bid-value', autoBidValue);
    currentBidInModalDisplayElement.text(formatAmount(currentBid));
    EVENT_BUS.dispatch(AUCTION_EVENTS.AUTO_BID_MODAL_OPENED, {
      autoBidValue,
    });
  };

  const onAutoBidConfirmed = () => {
    const autoBidAmount = bidUntilDisplayElement.attr('data-bid-value');
    const autoBidValue = parseInt(autoBidAmount);
    EVENT_BUS.dispatch(AUCTION_EVENTS.AUTO_BID_CONFIRMED, {
      autoBidValue,
    });
  };

  autoBidButton.on('click', onAutoBidClicked);
  autoBidConfirmButton.on('click', onAutoBidConfirmed);

  $(window).on('unload', () => {
    autoBidButton.off('click', onAutoBidClicked);
  });
});
